<!-- <div *ngIf="uploadType=='single'">
  <mat-label>Choose File</mat-label>
  <input type="file" (change)="uploadFile($event)" />
</div>

<div *ngIf="uploadType=='multiple'">
  <mat-label>Choose File</mat-label>
  <input type="file" multiple (change)="uploadMultiple($event)" />
</div> -->



<div class="message" *ngIf="isInProgress">
  <div style="margin-bottom: 14px;">Uploading...
    <mat-progress-bar mode="determinate" value="{{progress}}"></mat-progress-bar>

  </div>
</div>
<!-- 
<div class="message" *ngIf="isInProgress">
  <mat-progress-bar mode="buffer"></mat-progress-bar>

  <button mat-button (click)="cancelUpload()">Cancel Upload</button>
</div>

<div class="message" *ngIf="completed">
  <h4>
    File has been uploaded successfully!
  </h4>
  <button (click)="resetUpload()">Upload Another File</button>
</div>

<div class="message error" *ngIf="hasFailed">
  Error: {{ error }}
</div> -->



<div class="documents tab_content" id="content7" data-tab="7">

  <!-- form FORM====================================FORM FORM=====================FORM -->
  <div class="form_input">
    <div class="top">
      <h2 class="title">New Document

      </h2>
      <!-- <button class="default_secondary-btn">Add New<em class="ti-plus"></em> </button> -->
    </div>

    <form [formGroup]="documentForm">
      <div class="input">
        <label for="">Document Title</label>
        <input type="text" formControlName="DocumentTitle" class="default_input reference-form" />
      </div>
      <div class="input">
        <label for="">Document Type</label>
        <select formControlName="DocumentTypeId" class="default_input reference-form">
          <option *ngFor="let documentType of documenttypes$ |async" [value]="documentType.id">
            {{ documentType.DocumentTypeName }}</option>
        </select>
      </div>

      <div class="input">
        <label for="">Document Type code</label>
        <select formControlName="DocumentTypeCodeId" class="default_input reference-form">
          <option *ngFor="let documentTypeCode of documenttypecodes$| async" [value]="documentTypeCode.id">
            {{ documentTypeCode.DocumentTypeCodeName }}</option>
        </select>
      </div>

      <div class="input">
        <label for="">Third Party Storage(URL)</label>
        <textarea type="text" formControlName="Url" (mouseleave)="doesFileExistwithURL()"
          class="default_input reference-form"></textarea>
        <div class="alert alert-danger" *ngIf="!fileExist">
          {{fileExistMsg}}
        </div>
      </div>

      <div class="input">
        <label for="">Classification</label>
        <select formControlName="SecurityId" class="default_input reference-form">
          <option *ngFor="let security of securityclassifications$ | async" [value]="security.id">
            {{ security.SecurityClassificationName }}</option>
        </select>
      </div>

      <div class="input">
        <label for="">File Location</label>
        <select formControlName="FileLocationId" class="default_input reference-form">
          <option *ngFor="let fileLocation of filelocations$| async" [value]="fileLocation.id">
            {{ fileLocation.FileLocationName }}</option>
        </select>
      </div>

      <div class="input">
        <label for="">Remark</label>
        <input type="text" formControlName="Remarks" class="default_input reference-form" />
      </div>
      <div class="upload_file" style="text-align: right">
        <input #file type="file" multiple (change)="onFilesAdded($event)" id="id_number" hidden />
        <span>file name</span>
        <button class="default_secondary-btn" (click)="file.click()">Upload File <em class="ti-file"></em> </button>
      </div>
    </form>

    <div class="btn_holder">
      <button type="submit" class="default_primary-button" (click)="onSubmit()" type="submit">
        <ng-container *ngIf="selectedIndex === null">
          Save &rarr;
        </ng-container>
        <ng-container *ngIf="selectedIndex !== null">
          Update &rarr;
        </ng-container>
      </button>
      <div class="refresh">
        <button mat-button (click)="onReset()">
          <em class="material-icons">
            settings_backup_restore
          </em> Reset</button>
      </div>
    </div>
  </div>

  <!-- <cradua-document-table
[documentTypeCodes]="documentTypeCodes"
[documentTypes]="documentTypes"
[selectedLandTitle]="selectedLandTitle"
[securityClassifications]="securityClassifications"
[fetchDocuments]="fetchDocuments"
[fileLocations]="fileLocations"
(emitSelectDoc)="onSelectDoc($event)"
(emitEdit)="onEdit($event)"
(emitUploadDoc)="onUploadDoc($event)"
(emitSaveManyDoc)="onSaveManyDoc($event)"
*ngIf="isLoadingDocument === false"
></cradua-document-table> -->

  <div id="doc-list" *ngIf="docs.length >0">
    <div class="top_btn-tab mt-2">
      <button class="default_secondary-btn geo_btn" (click)="upload.click()">Upload Excel</button>
      <button class="default_secondary-btn geo_btn" (click)="export()">Download Excel</button>
      <mat-icon class="float-right close" title="vfxgfxgdfd" (click)="closeDialog()">close</mat-icon>
    </div>
    <input id="files" style="visibility: hidden;" type="file" #upload (change)="onUploadDoc($event)" />

    <div class="toggle_view">
      <mat-button-toggle-group name="fontStyle" aria-label="Font Style" color="accent" class="m-3">
        <mat-button-toggle value="list" color="accent" (click)="toggleView()">
          <mat-icon class="example-tab-icon">list</mat-icon>
        </mat-button-toggle>
        <mat-button-toggle value="grid" (click)="toggleView()">
          <mat-icon class="example-tab-icon">view_module</mat-icon>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>


    <div class="entry_values" *ngIf="gridView">
      <div class="entry" *ngFor="let document of docs; index as i">
        <h1 class="section_name">
          <span class="numb">{{i + 1}}.</span>
          <div class="first-detail">
            <span class="name">{{document?.DocumentTitle}} - </span>
            <span class="id">{{document?.DocRefNo}}</span>
          </div>
          <span (click)="$event.stopImmediatePropagation()" style="cursor: pointer;">
            <em class="ti-pencil" (click)="onEdit(doc.getRawValue(), i)"></em> 
          </span>
        </h1>

        <div class="other_info">
          <p class="purpose">
            <span>Local: </span>
            <span (click)="onSelectDoc(document?.getRawValue())" style="cursor: pointer;">ELP Storage</span>
          </p>

          <p class="net_area">
            <span>Third Party Storage: </span>
            <span><a href="{{document.Url}}" target="_blank">{{document.Url}}</a></span>
          </p>

          <p class="net_area">
            <span>Document Type: </span>
            <span>{{getDocumentTypeName(document?.DocumentTypeId)}}</span>
          </p>

          <p class="uom">
            <span>Document Type Code: </span>
            <span>{{getDocumentTypeCodeName(document?.DocumentTypeCodeId)}}</span>
          </p>

          <p class="cost">
            <span>URL: </span>
            <span>{{document?.Url}}</span>

          </p>

          <p class="map">
            <span>Security Classification: </span>
            <span>{{getSecurityClassificationName(document?.SecurityId)}}</span>
          </p>

          <p class="map">
            <span>File Location: </span>
            <span>{{getFileLocationName(document?.FileLocationId)}}</span>
          </p>

          <p class="map">
            <span>Remarks: </span>
            <span>{{document?.Remarks}}</span>
          </p>
        </div>
      </div>
    </div>


    <div class="card mt-3" *ngIf="listView">
      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col">S/N</th>
            <th scope="col">Document Title</th>
            <th scope="col">DocRefNo</th>
            <th scope="col">Local</th>
            <th scope="col">Third Party Storage</th>
            <th scope="col">Document Type</th>
            <th scope="col">Document Type Code</th>
            <th scope="col">URL</th>
            <th scope="col">Security Classification</th>
            <th scope="col">File Location</th>
            <th scope="col">Remarks</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let document of docs; index as i">
            <td scope="row">{{i + 1}}</td>
            <td>{{document?.DocumentTitle}}</td>
            <td>{{document?.DocRefNo}}</td>
            <td> <span (click)="onSelectDoc(document)" style=" cursor: pointer;">ELP Storage</span></td>
            <td><a href="{{document.Url}}" target="_blank">{{document.Url}}</a></td>
            <td>{{getDocumentTypeName(document?.DocumentTypeId)}}</td>
            <td>{{getDocumentTypeCodeName(document?.DocumentTypeCodeId)}}</td>
            <td>{{document?.Url}}</td>
            <td>{{getSecurityClassificationName(document?.SecurityId)}}</td>
            <td>{{getFileLocationName(document?.FileLocationId)}}</td>
            <td>{{document?.Remarks}}</td>
            <td (click)="$event.stopImmediatePropagation()" style="cursor: pointer;">
              <em class="ti-pencil" (click)="onEdit(documentArrayForm.getRawValue(), i)"></em> 
            </td>
          </tr>

        </tbody>
      </table>

    </div>
  </div>

  <cradua-list-spinner *ngIf="isLoadingDocument === true">
  </cradua-list-spinner>

</div>